import { DonutChartComponent } from '../charts/donut-chart-component'

export class AFGenderStacked extends DonutChartComponent {
 static config = {
  selector: 'afGenderStacked',
  controller: AFGenderStacked,
  bindings: DonutChartComponent.config.bindings,
  template: DonutChartComponent.config.template,
 }

 toolTipLabel: any = 'Gender'
 showLegend = false
 areDataLabelsVisible: boolean = true

 setProperties() {
  this.seriesData = this.namingUtils.getGenderType(this.vizData.data.all)
  this.seriesColors = this.colorUtils.setGenderColorPalette(this.vizData.data.all)
 }

 isChartClickable() {
  return false
 }
}
